/**
 * @generated SignedSource<<daca393877d4cdc54117aeb3cb333c2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraBoardType = "KANBAN" | "SCRUM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type UserBoardHeader_board$data = {
  readonly boardId: AGG$Long;
  readonly boardType: JiraBoardType;
  readonly name: string;
  readonly " $fragmentType": "UserBoardHeader_board";
};
export type UserBoardHeader_board$key = {
  readonly " $data"?: UserBoardHeader_board$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserBoardHeader_board">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserBoardHeader_board",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "boardId"
      },
      "action": "THROW",
      "path": "boardId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "boardType"
      },
      "action": "THROW",
      "path": "boardType"
    }
  ],
  "type": "JiraBoard"
};

(node as any).hash = "8e9eefe98b582988ed6ecfcea8baeeac";

export default node;
